<template functional>
  <svg
    v-tooltip.right="$options.methods.getTooltip(props)"
    :viewBox="$options.methods.getViewBoxMain(props)"
    class="icon sprite-icon"
    :class="$options.methods.getStyleClasses(props)"
    v-bind="data.attrs"
    role="presentation"
    v-on="listeners"
  >

    <svg
      :viewBox="$options.methods.getViewBox(props)"
    >
      <title>{{ props.title || props.name }}</title>
      <desc v-if="props.desc">{{ props.desc }}</desc>
      <path :d="$options.methods.getPath(props)" />
    </svg>
  </svg>
</template>

<script>
  import icons from './icons.json';

  export default {
    name: "AppIcon",
    props: {
      name: {
        type: String,
        default: ''
      },
      size: {
        type: String,
        default: ''
      },
      color: {
        type: String,
        default: ''
      },
      title: {
        type: String,
        default: ''
      },
      desc: {
        type: String,
        default: ''
      },
      tooltip: {
        type: String,
        default: ''
      },
      otherclass: {
        type: String,
        default: ''
      }
    },
    methods: {
      getViewBoxMain(props) {
        if (props.name == 'olymp-three-dots-icon') {
          return '0 0 12 12';
        } else {
          return '0 0 24 24';
        }
      },
      getViewBox(props) {
        if (props.name == 'olymp-three-dots-icon') {
          return '0 0 128 32';
        } else if (props.name == 'olymp-shopping-bag-icon') {
          return '0 0 512 512';
        } else {
          return '0 0 32 32';
        }
      },
      getTooltip(props) {
        return props.tooltip || '';
      },
      getPath(props) {
        return icons[props.name];
      },
      getStyleClasses(props) {

        return `${props.otherclass} is-${props.size} is-${props.color}`;
      }
    },
  };
</script>

<style>
  /* default */
  .icon {
    width: 1.2em;
    height: 1.2em;
    fill: currentColor;
  }

  /* sizes */
  .icon.is-large {
    width: 2em;
    height: 2em;
  }
  .icon.is-medium {
    width: 1.6em;
    height: 1.6em;
  }
  .icon.is-normal {
    width: 1.2em;
    height: 1.2em;
  }
  .icon.is-small {
    width: 1em;
    height: 1em;
  }
  .icon.is-tiny {
    width: 0.8em;
    height: 0.8em;
  }

  /* colors */
  .icon.is-primary,
  .icon.is-blue {
    fill: #2196F3
  }
  .icon.is-success,
  .icon.is-green {
    fill: #4CAF50
  }
  .icon.is-danger,
  .icon.is-red  {
    fill: #F44336
  }
  .icon.is-warning,
  .icon.is-orange {
    fill: #FF9800
  }
  .icon.is-gray {
    fill: #9a9fbf
  }
  .icon.is-white {
    fill: #ffffff;
  }
  .icon.is-dark-gray{
    fill: #3f4257;
  }
  .icon.is-black{
    fill: #000000;
  }
</style>